export default "__VITE_ASSET__a996f863__"